<template>
  <v-card outlined>
    <v-card-title
      ><v-row>
        <v-col class="py-0"> Points of Interest</v-col
        ><v-col sm="2" class="py-0">
          <v-container fluid py-0>
            <v-row justify="end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-2"
                    small
                    fab
                    dark
                    color="primary"
                    @click="onAdd"
                  >
                    <v-icon dark small>mdi-plus</v-icon>
                  </v-btn>
                </template>
                Add POI
              </v-tooltip>
            </v-row>
          </v-container>
        </v-col>
      </v-row></v-card-title
    >
    <v-data-table :items="pois" :headers="headers">
      <template v-slot:item.actions="{ item }">
        <default-list-actions
          :item="item"
          @deleteItem="deletePoi"
          @editItem="editPoi"
          hide-view
        ></default-list-actions>
      </template>
    </v-data-table>
    <poi-dialog
      v-model="selectedPOI"
      @close="showPOIDialog = false"
      :show="showPOIDialog"
      :map-center="mapCenter"
      @save="onPoiSave"
      :path="path"
    ></poi-dialog>
    <div v-if="debug">
      <code>{{ pois }}</code>
    </div>
  </v-card>
</template>

<script>
import PoiDialog from "./POIDialog";
import DefaultListActions from "../../shared/DefaultListActions";
import gql from "graphql-tag";
const CREATE_POI = gql`
  mutation createRoutePoi($routeId: ID!, $poi: RoutePoiInput!) {
    createRoutePoi(routeId: $routeId, poi: $poi) {
      id
      name
      lat
      lng
      description
      audio
      type {
        id
        name
        iconName
        iconSVG
      }
    }
  }
`;
const UPDATE_POI = gql`
  mutation updateRoutePoi($id: ID!, $poi: RoutePoiInput!) {
    updateRoutePoi(id: $id, poi: $poi) {
      id
      name
      lat
      lng
      description
      audio
      type {
        id
        name
        iconName
        iconSVG
      }
    }
  }
`;
const DELETE_POI = gql`
  mutation deleteRoutePoi($id: ID!) {
    deleteRoutePoi(id: $id) {
      id
      name
      lat
      lng
      description
      audio
      type {
        id
        name
        iconName
      }
    }
  }
`;
export default {
  name: "route-pois",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    mapCenter: {
      type: Object,
      default: () => null,
    },
    routeId: {
      type: String,
      default: () => "",
    },
    path: {
      type: Array,
      default: () => [],
    },
    isSource: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { PoiDialog, DefaultListActions },

  data() {
    return {
      debug: false,
      selectedPOI: null,
      showPOIDialog: false,
      pois: this.value ? [...this.value] : [],
      editedIndex: null,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Description",
          value: "description",
          name: "description",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  watch: {
    value(newVal) {
      this.pois = [...newVal];
    },
  },

  methods: {
    onAdd() {
      this.selectedPOI = {
        name: "New Point of Interest",
        description: "Some description...",
        audio: false,
      };
      this.showPOIDialog = true;
    },
    onPoiSave() {
      this.showPOIDialog = false;
      if (this.isSource) {
        this.$emit("save", { ...this.selectedPOI });
      } else {
        if (this.selectedPOI.id) {
          const { id, type, ...poi } = this.selectedPOI;
          poi.typeId = type.id;
          this.$apollo
            .mutate({
              mutation: UPDATE_POI,
              variables: {
                id,
                poi,
              },
            })
            .then((res) => {
              Object.assign(this.pois[this.editedIndex], {
                ...res.data.updateRoutePoi,
              });

              this.$emit("input", [...this.pois]);
            })
            .catch((err) => console.error(err));
        } else {
          const { type, ...poi } = this.selectedPOI;
          poi.typeId = type.id;
          this.$apollo
            .mutate({
              mutation: CREATE_POI,
              variables: {
                routeId: this.routeId,
                poi,
              },
            })
            .then((res) => {
              this.pois.push({ ...res.data.createRoutePoi });
              this.$emit("input", [...this.pois]);
            })
            .catch((err) => console.error(err));
        }
      }
    },
    deletePoi(payload) {
      if (this.isSource) {
        this.$emit("delete", { ...payload });
      } else {
        this.selectedPOI = { ...payload };
        this.$apollo
          .mutate({
            mutation: DELETE_POI,
            variables: {
              id: this.selectedPOI.id,
            },
          })
          .then((res) => {
            this.pois = [
              ...this.pois.filter((poi) => poi.id != this.selectedPOI.id),
            ];
            this.$emit("input", [...this.pois]);
          })
          .catch((err) => console.error(err));
      }
    },
    editPoi(payload) {
      this.editedIndex = this.pois.map((p) => p.id).indexOf(payload.id);
      this.selectedPOI = { ...payload };
      this.showPOIDialog = true;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/routes/RoutePOIS.vue